/**
 * Speaker Page
 *
 * @since 2.7.4
 */

(() => {
	// Wait for a DOM load
	document.addEventListener( 'DOMContentLoaded', () => {
		// Get the podcasts swiper element
		const podcastsSwiperElement = document.querySelector('.as-news-podcasts-swiper');

		// If it exists, initialize the Swiper
		if (podcastsSwiperElement) {
			const podcastsSwiper = new Swiper(podcastsSwiperElement, {
				// Swiper options
				navigation: {
					nextEl: '.as-news-podcasts-swiper-next',
					prevEl: '.as-news-podcasts-swiper-prev',
				},
				pagination: {
					el: '.as-news-podcasts-swiper-pagination',
					clickable: true,
				},
				slidesPerGroup: 1,
				slidesPerView: 1,
				spaceBetween: 0,
				breakpoints: {
					768: {
						slidesPerView: 2,
						slidesPerGroup: 2,
						spaceBetween: 0,
					},
				},
			});
		}

		// Try to grab the articles swiper element
		const articlesSwiperElement = document.querySelector('.as-news-articles-swiper');

		// If it exists, initialize the Swiper
		if (articlesSwiperElement) {
			const articlesSwiper = new Swiper(articlesSwiperElement, {
				// Swiper options
				loop: true,
				navigation: {
					nextEl: '.as-news-articles-swiper-next',
					prevEl: '.as-news-articles-swiper-prev',
				},
				pagination: {
					el: '.as-news-articles-swiper-pagination',
					clickable: true,
				},
				slidesPerGroup: 1,
				slidesPerView: 1,
				spaceBetween: 25,
				breakpoints: {
					768: {
						slidesPerView: 2,
						slidesPerGroup: 2,
						spaceBetween: 0,
					},
					1024: {
						slidesPerView: 3,
						slidesPerGroup: 3,
						spaceBetween: 0,
					},
				},
			});
		}
	} );
})();